export const getRandomNumber = (range: number) => {
  return Math.abs(Math.floor(Math.random() * range));
};
